export default __webpack_public_path__ + "static/media/sbp.ec5f7868.png";